import IncidentSection6 from './IncidentSection6';

export default IncidentSection6;
